/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["mi","subah","dopahar","shaam","raat"],["midnight","subah","dopahar","shaam","raat"],["aadhi raat","subah","dopahar","shaam","raat"]],[["midnight","morning","afternoon","evening","night"],u,["aadhi raat","subah","dopahar","shaam","raat"]],["00:00",["04:00","12:00"],["12:00","16:00"],["16:00","20:00"],["20:00","04:00"]]];
